
import React, { useEffect, useState, useRef } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { useNavigate } from 'react-router-dom';
import PaginationTable from '../../pagination/Pagination4';

const version_abs1 = async (dist_code, afso_code) => {

    const response = await fetch(
        `${process.env.REACT_APP_URL_SIDE}/api/beneficiary/fpscount`,
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                dist_code: dist_code,
                afso_code: afso_code
            })
        }
    );

    if (!response.ok) {
        throw new Error("Failed to fetch data");
    }

    return await response.json();
};


const Ben_Ver_Abstract = ({ dist_code, afso_code }) => {

    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [tabHeading, setTabHeading] = useState("");
    const [searchQuery, setSearchQuery] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);

    const navigate = useNavigate();
    const detailsRRef = useRef(null);


    useEffect(() => {
        const getData = async () => {
            try {
                const response_data = await version_abs1(dist_code, afso_code);

                setTabHeading(response_data?.heading || "");

                if (response_data?.data && response_data.data.length > 0) {
                    setReportData(response_data.data);
                } else {
                    setReportData([]);
                }

            } catch (errorr) {
                setError(errorr);
            } finally {
                setLoading(false);
            }
        };

        getData();
    }, [dist_code, afso_code]);


    useEffect(() => {
        setPage(0);
    }, [searchQuery]);


    const filteredData = reportData.filter(item => {
        const searchLower = searchQuery.toLowerCase();

        if (!searchLower) return true;
        return (
            (item?.fps_id || "").toString().toLowerCase().includes(searchLower) ||
            (item?.today_ekyc || 0).toString().includes(searchLower) ||
            (item?.app_today || 0).toString().includes(searchLower) ||
            (item?.month_ekyc || 0).toString().includes(searchLower) ||
            (item?.app_month || 0).toString().includes(searchLower) ||
            (item?.total_ekyc || 0).toString().includes(searchLower) ||
            (item?.total_app || 0).toString().includes(searchLower)
        );
    });


    const paginatedData =
        rowsPerPage >= filteredData.length
            ? filteredData
            : filteredData.slice(page * rowsPerPage, (page + 1) * rowsPerPage);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (value) => {
        if (value === 'all') {
            setRowsPerPage(filteredData.length);
        } else {
            setRowsPerPage(parseInt(value, 10));
        }
        setPage(0);
    };




    useEffect(() => {
        if (!loading && !error && reportData.length > 0 && detailsRRef.current) {
            detailsRRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }, [loading, error, reportData]);


    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Box sx={{ display: 'flex' }}>
                    <CircularProgress />
                </Box>
            </div>
        );
    }

    if (error) {
        return (
            <div className="mainhead" align="center">
                Internal Error
            </div>
        );
    }

    if (reportData.length === 0) {
        return (
            <div className="mainhead" align="center">
                No data found
            </div>
        );
    }

    const totals = reportData.reduce(
        (acc, item) => {
            acc.today_total_app += item.today_ekyc || 0;
            acc.today_app_today += item.app_today || 0;

            acc.month_month_ekyc += item.month_ekyc || 0;
            acc.month_app_month += item.app_month || 0;

            acc.total_total_ekyc += item.total_ekyc || 0;
            acc.total_total_app += item.total_app || 0;

            return acc;
        },
        {
            today_total_app: 0,
            today_app_today: 0,

            month_month_ekyc: 0,
            month_app_month: 0,

            total_total_ekyc: 0,
            total_total_app: 0,
        }
    );


    return (
        <>
            <br /><br />
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    width: '60%',
                    margin: '0 auto',
                    marginBottom: '20px'
                }}
            >
                <div style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
                    <PaginationTable
                        count={filteredData.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </div>

                <div>
                    <input
                        type="text"
                        placeholder="Search FPS ID"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        style={{ padding: '8px', width: '300px' }}
                    />
                </div>
            </div>

            <table align="center" width="50%" border={1}>
                <thead>
                    <tr>
                        <th className="tableheader" colSpan={10}>
                            {tabHeading}
                        </th>
                    </tr>
                    <tr className="tableheader">
                        <th rowSpan="3">Sl.No</th>
                        <th rowSpan="3">FPS</th>
                        <th colspan="4">Performed</th>
                        <th rowspan="2" colspan="2" >Total</th>
                    </tr>
                    <tr class="tableheader">
                        <th colspan="2" >Today</th>
                        <th colspan="2" >current month</th>
                    </tr>
                    <tr class="tableheader">
                        <th>key Register</th>
                        <th>New App</th>
                        <th>key Register</th>
                        <th>New App</th>
                        <th>key Register</th>
                        <th>New App</th>
                    </tr>

                </thead>

                <tbody>
                    {paginatedData.map((item, index) => (
                        <tr key={item.fps_id}>
                            <td style={{ textAlign: 'center' }}>
                                {page * rowsPerPage + index + 1}
                            </td>
                            <td style={{ textAlign: 'left' }}>
                                {item.fps_id}
                            </td>
                            <td style={{ textAlign: 'right' }}>  {item.today_ekyc ?? 0}</td>
                            <td style={{ textAlign: 'right' }}>{item.app_today ?? 0}</td>
                            <td style={{ textAlign: 'right' }}>{item.month_ekyc ?? 0}</td>
                            <td style={{ textAlign: 'right' }}>{item.app_month ?? 0}</td>
                            <td style={{ textAlign: 'right' }}>{item.total_ekyc ?? 0}</td>
                            <td style={{ textAlign: 'right' }}>{item.total_app ?? 0}</td>

                        </tr>
                    ))}

                    <tr className="tableheader">
                        <td colSpan={2} style={{ textAlign: 'center', fontWeight: 'bold' }}>Total</td>
                        <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.today_total_app ?? 0}</td>
                        <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.today_app_today ?? 0}</td>
                        <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.month_month_ekyc ?? 0}</td>
                        <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.month_app_month ?? 0}</td>
                        <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.total_total_ekyc ?? 0}</td>
                        <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.total_total_app ?? 0}</td>

                    </tr>
                </tbody>
            </table>

            <br /><br />

            <div ref={detailsRRef}></div>

        </>
    );
};

export default Ben_Ver_Abstract;